import { css } from "emotion";
import withGoogleMapsApi from "../withGoogleMapsApi";
import { Component } from "preact";
import React from "react";
import PlacesAutocomplete, {
  geocodeByAddress
} from "react-places-autocomplete";
import { connect } from "react-redux";
import config from "../../../config";
import { setRefinements } from "../../../state/actions/searchActions";
import { getSize } from "../../../utils/BrowserUtils";

const magnifyingGlass = require("../../../assets/ic_location_grey.svg");

const wrapper = css({
  height: 40,
  maxWidth: 200,
  minWidth: 200
});

const locationWrapper = css({
  position: "relative",
  float: "left",
  width: "100%",
  height: 40
});

const locationSearch = css({
  width: "100%",
  height: 40,
  border: "solid 1px #8D949E",
  borderRadius: 4,
  backgroundColor: "#fff",
  paddingLeft: 30,
  backgroundImage: `url(${magnifyingGlass})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "4px 6px",
  fontSize: 16
});

const locationDropDown = css({
  position: "absolute",
  zIndex: 99999,
  borderRadius: 4,
  boxShadow: "0px 1px 10px 0px rgba(9, 30, 66, 0.13)",
  width: "100%"
});

const locationItem = css({
  width: "100%",
  height: 40,
  backgroundColor: "white",
  padding: "12px 0px 12px 12px",
  overflow: "hidden",
  textAlign: "left",
  fontSize: 14
});

const locationItemActive = css({
  width: "100%",
  height: 40,
  backgroundColor: "#f9f9fa",
  padding: "12px 0px 12px 12px",
  overflow: "hidden",
  textAlign: "left"
});

class LocationRefinement extends Component {
  menuStringtrimmer(str) {
    let response = str;
    const innerWidth = getSize().innerWidth;
    if (innerWidth) {
      return response.length > 19
        ? response.substring(0, 20) + "..."
        : response;
    }
    return response.length >= innerWidth / 11
      ? response.substring(0, innerWidth / 11 + 1).concat("...")
      : response;
  }

  handleChange = address => {
    const { setRefinements } = this.props;
    setRefinements({
      address: address,
      bounds: [],
      latlng: null,
      displayAddress: ""
    });
    if (address === "") {
      setRefinements({
        bounds: [],
        latlng: null,
        address: "",
        displayAddress: ""
      });
    }
  };

  handleSelect = address => {
    geocodeByAddress(address)
      .then(results => {
        const bounds = [
          results[0].geometry.bounds.pa.h,
          results[0].geometry.bounds.ka.h,
          results[0].geometry.bounds.pa.g,
          results[0].geometry.bounds.ka.g
        ];
        this.props.setRefinements({
          bounds: bounds,
          latlng: `${results[0].geometry.location.lat()}, ${results[0].geometry.location.lng()}`,
          address: results[0].formatted_address,
          displayAddress: results[0].formatted_address
        });
      })
      .catch(error => console.error("Error", error));
  };

  constructor(props) {
    super(props);
    this.state = { address: "" };
  }

  render() {
    const { searchComponent = {}, GoogleMaps } = this.props;
    const { address } = searchComponent;
    return (
      <div className={wrapper}>
        <PlacesAutocomplete
          onChange={this.handleChange}
          onSelect={this.handleSelect}
          value={address}
          searchOptions={{
            location: new GoogleMaps.LatLng(
              config("SEARCH_PREFERENCE_LAT"),
              config("SEARCH_PREFERENCE_LNG")
            ),
            radius: 4000000,
            types: ["(regions)"]
          }}
        >
          {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading
          }) => {
            let params = getInputProps({
              placeholder: "Search Places ...",
              className: locationSearch //'location-search-input',
            });
            return (
              <div className={locationWrapper}>
                <input
                  {...params}
                  onChange={() => {}}
                  onInput={e => {
                    params.onChange(e);
                  }}
                  aria-label="Location Search"
                />
                <div className={locationDropDown}>
                  {suggestions.map(suggestion => {
                    const className = suggestion.active
                      ? locationItemActive
                      : locationItem;
                    const style = suggestion.active
                      ? locationItemActive
                      : locationItem;
                    return (
                      <div
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style
                        })}
                      >
                        <span>
                          {this.menuStringtrimmer(suggestion.description)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          }}
        </PlacesAutocomplete>
      </div>
    );
  }
}

export default connect(
  state => ({
    searchComponent: state.search.searchComponent
  }),
  { setRefinements }
)(withGoogleMapsApi(config("GOOGLE_API_KEY"))(LocationRefinement));
